import {dataService} from "../App";
/**
 *
 * @param {object} data info about user
 * @return {object} otp of users / error
 */

const profileServiceUrl='/users/profile';

export function getRemainingCredit() {

  return dataService.get(
    `${profileServiceUrl}/remainingcredit`,
  );
}

export function getUserProfileInfo() {

  return dataService.get(
    `${profileServiceUrl}/userProfileInfo`,
  );
}

export function getAuthorizationStatus() {

  return dataService.get(
    `${profileServiceUrl}/authorizationstatus`,
  );
}

export function sendContactUsMail(data) {
  let form = new FormData();
  form.append("email", data.email);
  form.append("selectedSubject", data.selectedSubject);
  form.append("messageText", data.messageText);
  form.append("additionalFile",data.additionalFile);
  return dataService.post(
    `${profileServiceUrl}/sendEMail`,form
  );
}